import { Editor } from "@tiptap/vue-3";
import { Ref } from "vue";
import { Events } from "../events";

export function BridgeEvents(editor: Ref<Editor>, editorNode) {

  Events.listen(Events.REPLACE_BLOCK, e => {
    let {content, block} = e.detail;

    content = content.trim()

    try {
      if (content.startsWith('<p>') && content.endsWith('</p>') && content.indexOf('<p>', 1) === -1) {
        content = content.substring(3, content.length - 4);
      }  
    } catch(e) {
      console.warn(e)
    }

    const {from, to} = block
    editor.value.chain()
      .focus()
      .insertContentAt({ from, to }, content)
      .setTextSelection({
        from: from+1, to: from+1
      })
      .scrollIntoView()
      .run()    
  })

  Events.listen(Events.SHOW_MARK_TO_FIX, e => {
    const markerEl = document.querySelector('.TheEditor .toFix');
    if (markerEl) {
      markerEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  })

  Events.listen(Events.DROP_BLOCK, e => {
    (editor.value.commands as any).withdrawToFix()
  })

  Events.listen(Events.INSERT_CONTENT, e => {
    editor.value.commands.insertContent(e.detail.content)
  })

  Events.listen(Events.SET_CONTENT, e => {    
    editor.value.commands.setContent(e.detail.content)
  })

  const eventGroup = Events.group()

  return () => {
    eventGroup.dispose()
  }
}
